import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ADD_AUTH } from '../../../../core/app-config.token';

@Injectable({
  providedIn: 'root',
})
export class SeguimientoExpService {
  private http = inject(HttpClient);

  constructor() {
  }
  searchExpedientebyNumber(
    expedienteId: any
  ): Observable<any> {
    const params = { numero: expedienteId };

    let headers = new HttpHeaders({
      'Content-type': 'application/json'
    });

    return this.http
      .post('find/expediente', params, {
        headers: headers,
        context: new HttpContext().set(ADD_AUTH, true),
      })
      .pipe(map((response) => response));
  }

  get_acta_imprimir(numSolic: any, tokenValue: any): Observable<any> {
    const params = { numSolic: numSolic };

    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http
      .post('acta/imprimir', params, { headers: headers, context: new HttpContext().set(ADD_AUTH, true) })
      .pipe(map((response) => response));
  }

  getHistorial(): Observable<any> {
    return this.http
      .get('find/historial', {
        context: new HttpContext().set(ADD_AUTH, true),
      })
      .pipe(map((response) => response));
  }

}
